import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const formatTimestamp = (timestamp) => {
  const date = timestamp.toDate();
  const dayjsDate = dayjs(date);
  let relativeTimeString = dayjsDate.fromNow();
  if (relativeTimeString === 'a day ago') {
    relativeTimeString = '1 day ago';
  }
  return relativeTimeString;
};

export default formatTimestamp;
